<template>
  <div>
    <hero-bar>
      Profilim
      <router-link
        slot="right"
        :to="{ name: 'home' }"
        class="button"
      >
        Dashboard
      </router-link>
    </hero-bar>
    <section class="section is-main-section">
      <tiles>
        <profile-update-form class="tile is-child" />
      </tiles>
      <password-update-form />
    </section>
  </div>
</template>

<script>
import HeroBar from '@/components/HeroBar'
import ProfileUpdateForm from '@/components/ProfileUpdateForm'
import PasswordUpdateForm from '@/components/PasswordUpdateForm'
import Tiles from '@/components/Tiles'
export default {
  name: 'Profile',
  components: { Tiles, PasswordUpdateForm, ProfileUpdateForm, HeroBar },
}
</script>
